import { Link } from "react-router-dom";
import { Heart } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-[#2D3748] text-white">
      {/* Donation Banner */}
      <div className="bg-gradient-to-r from-[#FFC4D6]/20 via-[#BDE0FE]/20 to-[#A0E8AF]/20 py-6">
        <div className="max-w-6xl mx-auto px-6 flex flex-col md:flex-row items-center justify-center gap-4 text-center md:text-left">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-[#FFC4D6] rounded-full flex items-center justify-center">
              <Heart className="w-5 h-5 text-[#591C2E]" fill="#591C2E" />
            </div>
            <div>
              <p className="text-[#2D3748] font-medium">
                Diese Seite ist <span className="text-[#1A4731] font-bold">kostenlos</span> und bleibt es auch!
              </p>
              <p className="text-sm text-[#718096]">
                Unterstütze uns mit einer kleinen Spende.
              </p>
            </div>
          </div>
          <a
            href="https://www.paypal.com/donate/?business=spritbard%40gmail.com&currency_code=EUR"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-[#0070ba] hover:bg-[#005ea6] text-white font-bold px-6 py-3 rounded-full transition-all hover:scale-105 shadow-md"
          >
            <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor">
              <path d="M7.076 21.337H2.47a.641.641 0 0 1-.633-.74L4.944 3.72a.77.77 0 0 1 .757-.629h6.488c2.165 0 3.74.543 4.685 1.615.906 1.027 1.195 2.399.86 4.08-.015.076-.032.152-.05.228-.21.932-.574 1.746-1.083 2.42-.536.71-1.222 1.274-2.04 1.679-.838.415-1.88.625-3.097.625H9.417a.77.77 0 0 0-.757.629l-.904 5.312a.641.641 0 0 1-.633.658h-.047z"/>
              <path d="M19.342 7.667c-.019.096-.041.195-.066.296-.797 3.466-3.426 4.677-6.826 4.677H10.85a.826.826 0 0 0-.815.678l-.878 5.158-.25 1.467a.435.435 0 0 0 .43.502h3.024a.688.688 0 0 0 .678-.566l.028-.14.537-3.158.034-.183a.688.688 0 0 1 .679-.567h.427c2.77 0 4.938-1.044 5.572-4.064.265-1.262.128-2.316-.573-3.056a2.607 2.607 0 0 0-.746-.544z"/>
            </svg>
            Mit PayPal spenden
          </a>
        </div>
      </div>

      {/* Main Footer */}
      <div className="max-w-6xl mx-auto px-6 py-12">
        <div className="grid md:grid-cols-5 gap-8">
          {/* Brand */}
          <div className="md:col-span-1">
            <img 
              src="/logo.png" 
              alt="mobbing-melden.de Logo" 
              className="h-12 w-auto mb-4 brightness-0 invert"
            />
            <p className="text-gray-400 text-sm">
              Ein sicherer Ort für Kinder und Jugendliche, um Mobbing zu melden und Hilfe zu bekommen.
            </p>
          </div>

          {/* Hilfe */}
          <div>
            <h4 className="font-bold text-white mb-4">Hilfe holen</h4>
            <ul className="space-y-2">
              <li><Link to="/melden" className="text-gray-400 hover:text-white transition-colors">Jetzt melden</Link></li>
              <li><Link to="/was-passiert" className="text-gray-400 hover:text-white transition-colors">Was passiert mit meiner Meldung?</Link></li>
              <li><Link to="/notfall" className="text-gray-400 hover:text-white transition-colors">Notfall-Hotlines</Link></li>
              <li><Link to="/faq" className="text-gray-400 hover:text-white transition-colors">Häufige Fragen</Link></li>
            </ul>
          </div>

          {/* Informieren */}
          <div>
            <h4 className="font-bold text-white mb-4">Informieren</h4>
            <ul className="space-y-2">
              <li><Link to="/selbstschutz" className="text-gray-400 hover:text-white transition-colors">Tipps zum Selbstschutz</Link></li>
              <li><Link to="/erfahrungen" className="text-gray-400 hover:text-white transition-colors">Erfahrungsberichte</Link></li>
              <li><Link to="/eltern" className="text-gray-400 hover:text-white transition-colors">Für Eltern</Link></li>
              <li><Link to="/lehrer" className="text-gray-400 hover:text-white transition-colors">Für Lehrer</Link></li>
            </ul>
          </div>

          {/* Ratgeber */}
          <div>
            <h4 className="font-bold text-white mb-4">Ratgeber</h4>
            <ul className="space-y-2">
              <li><Link to="/blog" className="text-gray-400 hover:text-white transition-colors">Alle Ratgeber</Link></li>
              <li><Link to="/blog/mobbing-am-arbeitsplatz" className="text-gray-400 hover:text-white transition-colors">Mobbing am Arbeitsplatz</Link></li>
              <li><Link to="/blog/mobbing-protokoll" className="text-gray-400 hover:text-white transition-colors">Mobbing Protokoll</Link></li>
              <li><Link to="/cybermobbing" className="text-gray-400 hover:text-white transition-colors">Cybermobbing</Link></li>
              <li><Link to="/betriebsrat" className="text-gray-400 hover:text-white transition-colors">Betriebsrat</Link></li>
            </ul>
          </div>

          {/* Rechtliches */}
          <div>
            <h4 className="font-bold text-white mb-4">Rechtliches</h4>
            <ul className="space-y-2">
              <li><Link to="/ueber-uns" className="text-gray-400 hover:text-white transition-colors">Über uns</Link></li>
              <li><Link to="/datenschutz" className="text-gray-400 hover:text-white transition-colors">Datenschutz</Link></li>
              <li><Link to="/impressum" className="text-gray-400 hover:text-white transition-colors">Impressum</Link></li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 mt-8 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-gray-400 text-sm">
            © 2024 mobbing-melden.de - Alle Rechte vorbehalten
          </p>
          <div className="flex items-center gap-4">
            <a href="https://www.klicksafe.de" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white text-sm">
              klicksafe.de
            </a>
            <a href="https://www.juuuport.de" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white text-sm">
              juuuport.de
            </a>
            <a href="https://www.nummergegenkummer.de" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white text-sm">
              Nummer gegen Kummer
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
